import React, { Fragment, useState, useEffect } from 'react';
import {
    Row,
    FormGroup,
    Label,
    Col,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownItem,
    DropdownToggle,
    DropdownMenu,
    Spinner,
    Modal, ModalHeader,
    ModalBody, ModalFooter, Button
} from 'reactstrap';
import Axios from 'axios';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    week,
    month,
    last7Days,
    last30Days,
    last60Days,
    last90Days,
    LastDays,
    year,
} from './lablesConfig';
import {
    gAPI_VisitorsGroups_Stats,
    gAPI_VisitorsGroupsMonth_Stats,
    gAPI_Service_Click,
    gAPI_Service_Item_Click_DateStatics,
    gAPI_Service_Avatar_Click_DateStatics
} from '../../../../../constants/APIs';
import moment from 'moment';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import VisitorVisitsChartCard from './CompendiumStats/VisitorVisitsChartCard';
import ItemClickStats from './CompendiumStats/ItemClickStats';
import ItemVisitsChartCard from './CompendiumStats/ItemVisitsChartCard';
import ItemTotalClicks from './CompendiumStats/ItemTotalClicks';
import AvatarClickStats from './CompendiumStats/AvatarClickStats';

const dataTableCompendiumColumns = [
    {
        Header: <IntlMessages id='dashboards.title' />,
        accessor: 'title',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
        Header: <IntlMessages id='dashboards.clicks' />,
        accessor: 'clicks',
        Cell: (props) => <p className="ml-3">{props.value}</p>,
    },
];
const avatarlabel = [
    {
        Header: 'URL',
        accessor: 'url',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
        Header: 'Timestamp',
        accessor: 'dateTime',
        Cell: (props) => <p className="ml-2">{moment(props.value).format('dddd, DD MMMM YYYY')} at {moment(props.value).format('h:mm a')}</p>,
    },
    {
        Header: 'Room',
        accessor: 'room',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
        Header: 'Stage',
        accessor: 'stage',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
        Header: 'Source',
        accessor: 'source',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
    {
        Header: 'Membership',
        accessor: 'member',
        Cell: (props) => <p className="ml-2">{props.value}</p>,
    },
];

export default function CompendiumCard({
    propertyId,
    isVoucherEngine,
    timeZone,
    domains,
    currency,
    history,
    integrationIdList
}) {
    moment.tz.setDefault(timeZone);
    const [buttonText, setButtonText] = useState(
        <IntlMessages id="dashboards.last-7-days" />
    );
    const [labels, setLabels] = useState(last7Days);
    const [isShow, setIsShow] = useState(false);
    const [isError, setError] = useState(false);
    const [message, setMessage] = useState('');
    const [filterDate, setFilterDate] = useState(false);
    const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
    const [endDate, setEndDate] = useState(moment().subtract(1, 'days'));
    const [isVisitorVisit, setIsVisitorVisit] = useState(true);
    const [visitorVisitStatsData, setVisitorVisitStatsData] = useState([]);
    const [isItemVisitStats, setIsItemVisitStats] = useState(false);
    const [itemVisitStatsData, setItemVisitStatsData] = useState([]);
    const [isItemClickStats, setIsItemClickStats] = useState(false);
    const [itemClickData, setItemClickData] = useState([]);
    const [isTotalCompendiumClicks, setIsTotalCompendiumClicks] = useState(false);
    const [avatarClickData, setAvatarClickData] = useState([]);
    const [isAvatarClick, setIsAvatarClick] = useState(false);
    const [visitorError, setVisitorError] = useState(null);
    const [itemVisitError, setItemVisitError] = useState(null);
    const [itemClickError, setItemClickError] = useState(null);
    const [avatarClickError, setAvatarClickError] = useState(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const today = () => {
        return moment(moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const daysAgo7 = () => {
        return moment(moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo30 = () => {
        return moment(moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo60 = () => {
        return moment(moment().subtract(60, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const daysAgo90 = () => {
        return moment(moment().subtract(90, 'days').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfWeek = () => {
        const today = moment().subtract(1, 'days');
        return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const endOfWeek = () => {
        const today = moment().subtract(1, 'days');
        return moment(
            moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfMonth = () => {
        return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
            .utc()
            .format('YYYY-MM-DD 00:00:00');
    };

    const startOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
            ' 00:00:00'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const startOfThisYear = () => {
        return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const startOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfLastYear = () => {
        return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
            'YYYY-MM-DD HH:mm:ss'
        );
    };

    const endOfPreviousMonth = () => {
        return moment(
            moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
            ' 23:59:59'
        )
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const endOfMonth = () => {
        return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
            .utc()
            .format('YYYY-MM-DD HH:mm:ss');
    };

    const handleStartDate = (date) => {
        setStartDate(moment(date))
    };

    const handleEndDate = (date) => {
        setEndDate(moment(date))
    };


    useEffect(() => {
        if (propertyId !== '' && propertyId !== undefined) {
            selectLast7Days();

        }
    }, [propertyId]);

    const StatContainer = ({ onRefresh, error, children }) => {
        return (
            <div>
                {error ? (
                    <Card className="text-center my-3" style={{ padding: '100px' }}>
                        <p style={{ color: 'red' }}>{error}</p>
                        <i
                            className="iconsminds-refresh"
                            style={{ fontSize: '40px', color: 'grey', cursor: 'pointer' }}
                            onClick={onRefresh}
                        />
                    </Card>
                ) : (
                    children
                )}
            </div>
        );
    };
    const fetchVisitorStats = async (dateFrom, dateTo) => {
        // console.log('date', dateFrom, dateTo);
        setIsVisitorVisit(true);
        setVisitorError(null);
        try {
            const response = await AxiosAPI({
                method: 'post',
                url: gAPI_VisitorsGroups_Stats,
                data: {
                    groupId: getGroupID(),
                    dateFrom,
                    dateTo,
                    propertyId: propertyId === "-1" ? null : propertyId,
                    integrationId: integrationIdList
                }
            });
            setVisitorVisitStatsData(response.data);
        } catch (error) {
            console.error("Visitor Stats Error:", error);
            setVisitorError("Failed to fetch visitor statistics");
        } finally {
            setIsVisitorVisit(false);
        }
    };


    const fetchItemVisitStats = async (dateFrom, dateTo) => {
        setIsItemVisitStats(true);
        setItemVisitError(null);
        try {
            const response = await AxiosAPI({
                method: 'get',
                url: gAPI_Service_Item_Click_DateStatics,
                params: {
                    groupId: getGroupID(),
                    propertyId,
                    dateFrom,
                    dateTo
                }
            });
            setItemVisitStatsData(response.data);
        } catch (error) {
            console.error("Item Visit Stats Error:", error);
            setItemVisitError("Failed to fetch item visit statistics");
        } finally {
            setIsItemVisitStats(false);
        }
    };

    const fetchItemClickStats = async (dateFrom, dateTo) => {
        setIsItemClickStats(true);
        setIsTotalCompendiumClicks(true);
        setItemClickError(null);
        try {
            const response = await AxiosAPI({
                method: 'get',
                url: gAPI_Service_Click,
                params: {
                    groupId: getGroupID(),
                    propertyId,
                    dateFrom,
                    dateTo,
                    lang: "en"
                }
            });
            setItemClickData(response.data);
        } catch (error) {
            console.error("Visitor Stats Error:", error);
            setItemClickError("Failed to fetch item click statistics");
        } finally {
            setIsItemClickStats(false);
            setIsTotalCompendiumClicks(false);
        }
    };

    const fetchAvatarClickStats = async (dateFrom, dateTo) => {
        setIsAvatarClick(true);
        setAvatarClickError(null);
        try {
            const response = await AxiosAPI({
                method: 'get',
                url: gAPI_Service_Avatar_Click_DateStatics,
                params: {
                    groupId: getGroupID(),
                    propertyId,
                    dateFrom,
                    dateTo
                }
            })
            setAvatarClickData(response.data);
        } catch (error) {
            console.error("Avator Stats Error:", error);
            setAvatarClickError("Failed to fetch avatar click statistics");
        } finally {
            setIsAvatarClick(false);
        }
    };
    const fetchVisitorVisitStats = async (dateFrom, dateTo) => {
        // console.log('date', dateFrom, dateTo);
        setIsVisitorVisit(true);
        setVisitorError(null);
        try {
            const response = await AxiosAPI({
                method: 'post',
                url: gAPI_VisitorsGroupsMonth_Stats,
                data: {
                    groupId: getGroupID(),
                    dateFrom,
                    dateTo,
                    propertyId: propertyId === "-1" ? null : propertyId,
                    integrationId: integrationIdList
                }
            });
            setVisitorVisitStatsData(response.data);
        } catch (error) {
            console.error("Visitor Stats Error:", error);
            setVisitorError("Failed to fetch visitor statistics");
        } finally {
            setIsVisitorVisit(false);
        }
    }
    const selectLast7Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-7-days" />);
        setLabels(last7Days);
        const from = daysAgo7();
        const to = today();
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectLast30Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-30-days" />);
        setLabels(last30Days);
        const from = daysAgo30();
        const to = today();
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };

    const selectLast60Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-60-days" />);
        setLabels(last60Days);
        const from = daysAgo60();
        const to = today();
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectLast90Days = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.last-90-days" />);
        setLabels(last90Days);
        const from = daysAgo90();
        const to = today();
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };

    const selectThisWeek = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.this-week" />);
        setLabels(week);
        const from = startOfWeek();
        const to = endOfWeek();
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };

    const handleFilterDateWise = (startDate, endDate) => {
        const from = startDate;
        const to = endDate;
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);

    }

    const selectThisMonth = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.this-month" />);
        setLabels(month);
        const from = startOfMonth();
        const to = endOfMonth();
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectPreviousMonth = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.previous-month" />);
        setLabels(month);
        const from = startOfPreviousMonth();
        const to = endOfPreviousMonth();
        setFromDate(from);
        setToDate(to);
        fetchVisitorStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectThisYear = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.yeartodate" />);
        setLabels(year);
        const from = startOfThisYear();
        const to = today();
        setFromDate(from);
        setToDate(to);
        fetchVisitorVisitStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const selectLastYear = () => {
        setFilterDate(false);
        setButtonText(<IntlMessages id="dashboards.lastyear" />);
        setLabels(year);
        const from = startOfLastYear();
        const to = endOfLastYear();
        setFromDate(from);
        setToDate(to);
        fetchVisitorVisitStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    };
    const handleFilterMonthWise = (startDate, endDate) => {
        const from = startDate;
        const to = endDate;
        setFromDate(from);
        setToDate(to);
        setLabels(year);
        fetchVisitorVisitStats(from, to);
        fetchItemVisitStats(from, to);
        fetchItemClickStats(from, to);
        fetchAvatarClickStats(from, to);
    }

    const handleFilter = () => {
        let diff = endDate.diff(startDate, 'days');
        setButtonText('Date Range');
        if (diff > 365) {
            setMessage("The start and end date must be within a year of each other.");
            setError(true);
            return;
        }
        if (diff > 90) {
            setIsShow(false);
            setLabels(year);
            handleFilterMonthWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);

        } else {
            if (diff >= 60)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 30)
                setLabels(LastDays(startDate, endDate));
            else if (diff >= 7)
                setLabels(LastDays(startDate, endDate));
            else
                setLabels(LastDays(startDate, endDate));
            setIsShow(false);
            handleFilterDateWise(moment(startDate).format('YYYY-MM-DD 00:00:00'), moment(endDate).format('YYYY-MM-DD') + ' 23:59:59');
            setFilterDate(true);
        }
    };

    return (
        <Fragment>
            <Row>
                <Col xxs="12" className="mb-2">
                    <Fragment>
                        {filterDate === true && <div className='float-left mt-2'>
                            <span className='mr-2'><b>From : </b>{moment(startDate).format('DD')}/{moment(startDate).format('MM')}/{moment(startDate).format('YYYY')}</span>
                            <span className='ml-2'><b>To : </b>{moment(endDate).format('DD')}/{moment(endDate).format('MM')}/{moment(endDate).format('YYYY')}</span>
                        </div>}
                        <div className="btn-group float-right float-none-xs mb-3">
                            <UncontrolledDropdown>
                                <DropdownToggle
                                    caret
                                    color="primary"
                                    className="btn-xs"
                                    outline
                                >
                                    {buttonText}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={selectLast7Days}>
                                        <IntlMessages id="dashboards.last-7-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast30Days}>
                                        <IntlMessages id="dashboards.last-30-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast60Days}>
                                        <IntlMessages id="dashboards.last-60-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLast90Days}>
                                        <IntlMessages id="dashboards.last-90-days" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisWeek}>
                                        <IntlMessages id="dashboards.this-week" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisMonth}>
                                        <IntlMessages id="dashboards.this-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectPreviousMonth}>
                                        <IntlMessages id="dashboards.previous-month" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectThisYear}>
                                        <IntlMessages id="dashboards.yeartodate" />
                                    </DropdownItem>
                                    <DropdownItem onClick={selectLastYear}>
                                        <IntlMessages id="dashboards.lastyear" />
                                    </DropdownItem>
                                    <DropdownItem onClick={() => setIsShow(!isShow)}>
                                        <IntlMessages id="form-components.date-range" />
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    </Fragment>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="12" className="mb-4">
                    <StatContainer error={itemClickError} onRefresh={() => fetchItemClickStats(fromDate, toDate)}>
                        {isTotalCompendiumClicks ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <ItemTotalClicks
                                itemList={itemClickData.itemClicks}
                                avatarClick={itemClickData.avatarClick}></ItemTotalClicks>
                        )}
                    </StatContainer>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="6" className="mb-4">
                    <StatContainer error={visitorError} onRefresh={() => fetchVisitorStats(fromDate, toDate)}>
                        {isVisitorVisit ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <VisitorVisitsChartCard
                                labels={labels}
                                visitorStatsData={visitorVisitStatsData}
                            />
                            // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        )}
                    </StatContainer>
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    <StatContainer error={itemVisitError} onRefresh={() => fetchItemVisitStats(fromDate, toDate)}>
                        {isItemVisitStats ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <ItemVisitsChartCard
                                labels={labels}
                                data={itemVisitStatsData}
                            />
                        )}
                    </StatContainer>
                </Col>
                <Col sm="12" md="6" className="mb-4">
                    <StatContainer error={itemClickError} onRefresh={() => fetchItemClickStats(fromDate, toDate)}>
                        {isItemClickStats ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <ItemClickStats
                                labels={dataTableCompendiumColumns}
                                data={itemClickData.itemClicks === null ? [] : itemClickData.itemClicks}
                            />
                            // <p style={{ textAlign: 'center' }}>Temporarily Unavailable</p>
                        )}
                    </StatContainer>
                </Col>
            </Row>
            <Row>
                <Col sm="12" md="12" className="mb-4">
                    <StatContainer error={avatarClickError} onRefresh={() => fetchAvatarClickStats(fromDate, toDate)}>

                        {isAvatarClick ? (
                            <div className="text-center">
                                <div className="text-center loading" />
                            </div>
                        ) : (
                            <AvatarClickStats
                                avatarlabel={avatarlabel}
                                data={avatarClickData}></AvatarClickStats>
                        )}
                    </StatContainer>
                </Col>
            </Row>

            <Modal isOpen={isShow}
                toggle={() => setIsShow(!isShow)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setIsShow(!isShow)}>
                    <IntlMessages id="form-components.date-range" />
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label><IntlMessages id='dashboards.start-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: "10px" }}
                                    selected={startDate ? new Date(startDate) : null} // ensure Date object
                                    onChange={handleStartDate}
                                    placeholderText="Start Date"
                                    dateFormat="dd/MM/yyyy"   // ✅ correct format
                                />
                            </FormGroup>
                        </Colxx>

                        <Colxx md="4" className="mb-2">
                            <FormGroup>
                                <Label> <IntlMessages id='dashboards.end-date' /></Label>
                                <DatePicker
                                    style={{ borderRadius: "10px" }}
                                    selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                                    onChange={handleEndDate}
                                    placeholderText="End Date"
                                    dateFormat="dd/MM/yyyy"   // ✅ correct format
                                />
                            </FormGroup>
                        </Colxx>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button color='primary' onClick={() => handleFilter()}>Submit</Button>
                    <Button className="ml-2" onClick={() => setIsShow(!isShow)}>Close</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={isError}
                toggle={() => setError(!isError)} style={{ borderRadius: '10px' }}>
                <ModalHeader toggle={() => setError(!isError)}>
                    BOOKMEBOB
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <p className='m-2'>{message}</p>
                    </Row>

                </ModalBody>
                <ModalFooter>
                    <Button className="ml-2" onClick={() => setError(!isError)}>Close</Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}